import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { resolverRenderer } from '../../renderers/lazy-renderer';
import { CommonModule } from '@angular/common';
import { SectionComponent } from '@tuain/ng-forms';
import { SECTION_RENDERERS, SectionRenderersMap } from './section-renderers.token';

@Component({
  standalone: true,
  selector: 'app-section',
  imports: [CommonModule],
  templateUrl: './app-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./app-section.component.scss'],
})
export class AppSectionComponent extends SectionComponent {
  private renderers = inject(SECTION_RENDERERS, { optional: true }) as SectionRenderersMap;
  widgetType = computed(() => this.customAttributes()?.['layout'] ?? 'default');
  componentToRender = resolverRenderer(this.renderers, this.widgetType);
}
